module.exports = __webpack_public_path__ + "static/media/42.aba782ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/42.jpg
// module id = 302
// module chunks = 0